import * as React from 'react';
import { ExpressPaymentMethod } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';

const useExpressCheckoutLabels = ()=>{
    const { getLabel  } = useIntl();
    const getTitle = React.useCallback((type)=>{
        switch(type){
            case ExpressPaymentMethod.GOOGLE_PAY:
                return getLabel('checkout.express.google.pay.header.title');
            case ExpressPaymentMethod.APPLE_PAY:
                return getLabel('checkout.express.apple.pay.header.title');
            case ExpressPaymentMethod.PAYPAL:
                return getLabel('checkout.express.paypal.header.title');
            default:
                return `Checkout with ${type}`;
        }
    }, [
        getLabel
    ]);
    return {
        getTitle,
        waitInstruction: getLabel('checkout.payment.wait.instruction')
    };
};

export { useExpressCheckoutLabels };
//# sourceMappingURL=use-express-checkout-labels.js.map
